import { useContext, useEffect } from "react";

import {
  InitializeMessage,
  UpdateTaskMessage,
} from "shared/actions/webSocketMessageActions";
import useWebSocket from "shared/hooks/useWebSocket";
import {
  SocketData,
  SocketStatus,
} from "shared/reducers/webSocketMessageReducer";

import BulkReportGenerationIndicator from "components/viewerLists/reportList/BulkReportGenerationIndicator";
import { useAppDispatch } from "store/hooks";

import { SocketMessageContext } from "./SocketMessageProvider";

const WebSocketGate = () => {
  //TODO: Reevaluate the usefulness of context here, the context currently is the message sending, the redux is the receiving.
  // Choose one or the other when determining websocket use.
  const { socketMessage, setSocketMessage } = useContext(SocketMessageContext);
  const dispatch = useAppDispatch();

  const onMessageData = (data: SocketData) => {
    if (data.type === "download_response") {
      if (
        data.status === SocketStatus.SUCCESS ||
        data.status === SocketStatus.FAILED
      ) {
        dispatch(UpdateTaskMessage(data));
      } else if (data.status === SocketStatus.INITIALIZED) {
        dispatch(InitializeMessage(data));
      }
    }
  };

  const socket = useWebSocket("viewer", {
    onOpen: () => {
      if (socketMessage && socket.current) {
        socket.current.send(socketMessage);
        setSocketMessage(null);
      }
    },
    onMessageData,
  });

  useEffect(() => {
    if (socketMessage) {
      if (!socket.current) {
        console.error("Socket does not exist");
      } else if (socket.current.readyState === WebSocket.OPEN) {
        socket.current.send(socketMessage);
        setSocketMessage(null);
      } else {
        socket.current.reconnect && socket.current.reconnect();
      }
    }
  }, [socketMessage]);

  return (
    <>
      <BulkReportGenerationIndicator />
    </>
  );
};

export default WebSocketGate;
